import { jsx as _jsx } from "react/jsx-runtime";
import ProfileContainer from "@components/profile-container";
import React from "react";
var TargetProfile = function(param) {
    var guestData = param.guestData, target = param.target;
    return /*#__PURE__*/ _jsx(ProfileContainer, {
        isResultPage: true,
        guestData: guestData,
        profileData: target,
        type: "targets"
    });
};
export var __N_SSG = true;
export default TargetProfile;
